<template>
  <Mescroll
    ref="mescroll"
    :down="mescrollDown"
    :up="mescrollUp"
    @init="mescrollInit"
  >
    <p
      v-if="!showList.length && !isLoading"
      class="center mt-20vh h5 text-secondary"
    >
      <template v-if="saved">您还没打过分哦</template>
      <template v-else>没有未打分的发言人</template>
    </p>
    <transition-group name="list">
      <template v-for="user in showList">
        <field-scored
          v-if="saved"
          v-model="user.score"
          :saved.sync="user.saved"
          :id="user.id"
          :pk="user.pk"
          :userName="user.userName"
          :userType="user.userType"
          :gender="user.gender"
          :key="user.id"
        ></field-scored>
        <van-cell-group v-else class="mt1_5" :key="user.id">
          <van-cell :title="user.userName" :value="user.deptName">
            <template slot="title">
              <div class="inline-block" style="width: 90px">{{ user.userName }}
              <van-tag v-if="user.userType == 3" color="#ffc107">请假</van-tag>
            </div>
              <van-tag
                v-if="user.base"
                color="#ffc107"
                round
                plain
              >{{ user.base }}</van-tag>
            </template>
            <i
              slot="icon"
              :class="['iconfont', 'mr1', user.gender === '女' ? 'icon-woman danger-light' : 'icon-man primary']"
            />
            <van-tag v-if="user.deptName" type="primary">{{ user.deptName }}</van-tag>
          </van-cell>
          <FieldUnScore
            v-model="user.score"
            :saved.sync="user.saved"
            :id="user.id"
            :userName="user.userName"
            :userType="user.userType"
            :focus="user.id === currentFocusedUserId"
            maxlength="3"
            placeholder="请输入分数（60~120分）"
            @focus-field="focusField"
            @focus-next-field="focusNextField"
          />
        </van-cell-group>
      </template>
    </transition-group>
  </Mescroll>
</template>

<script>
import Mescroll from 'mescroll.js/mescroll.vue'
import FieldUnScore from './FieldUnScore'
import FieldScored from './FieldScored'

export default {
  name: 'UserScoreList',
  components: {
    Mescroll,
    FieldUnScore,
    FieldScored
  },
  props: {
    /* 是否是结果页 */
    saved: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      mesroll: null,
      mescrollDown: {}, // 下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的，则可以省略 mescrollDown)
      // 上拉加载的配置.
      mescrollUp: {
        callback: this.upCallback, // 上拉回调
        page: {
          num: 0, // 当前页默认 0，回调之前会加1; 即 callback(page) 会从 1 开始
          size: 300 // 每页数据条数，默认 10
        },
        isBounce: false,
        loadFull: {
          use: true,
          delay: 100
        },
        htmlNodata: '<span class="upwarp-nodata">没有更多数据</span>'
        // noMoreSize: 5 // 如果列表已无数据，可设置列表总数大于 5 才显示无更多数据；避免列表数据过少，显示无更多数据会不好看
      },
      isLoading: false,
      currentFocusedUserId: null,
      list: []
    }
  },
  computed: {
    showList() {
      return this.list.filter(user => user.saved === this.saved)
    }
  },
  methods: {
    mescrollInit(mescroll) {
      this.mescroll = mescroll
    },

    async upCallback({ num: pageIndex, size: pageSize }, mescroll) {
      this.isLoading = true
      try {
        const scoredList = await this.getScoredList()
        if (this.saved) {
          this.list = scoredList
          this.isLoading = false
          this.$nextTick(() => {
            mescroll.endBySize(scoredList.length, scoredList.totalCount)
          })
          return
        }
        const { list: allList, totalPage } = await this.getAllList(
          pageIndex,
          pageSize
        )
        this.isLoading = false
        const unscoreList = allList.filter(
          user => !scoredList.map(user => user.id).includes(user.id)
        )
        if (pageIndex === 1) {
          this.list = []
        }
        this.list = this.list.concat(unscoreList)
        this.$nextTick(() => {
          mescroll.endByPage(allList.length, totalPage)
        })
      } catch (error) {
        this.isLoading = false
        mescroll.endErr()
      }
    },

    getAllList(pageIndex, pageSize) {
      return this.$http({
        method: 'get',
        url: 'speakers',
        params: {
          pageindex: pageIndex,
          pagenum: pageSize
        }
      }).then(response => {
        this.$emit('update-all-count', response.count)
        return {
          list: this.formatList(response.datas),
          totalPage: response.totalPage
        }
      })
    },

    getScoredList() {
      return this.$http({
        url: 'scoresult',
        method: 'post'
      }).then(response => {
        const scoredList = this.formatList(response, true)
        this.$emit('update-scored-count', scoredList.length)
        return scoredList
      })
    },

    formatList(list, isScoredList = false) {
      return list.map(user => ({
        id: isScoredList ? user.targetuid : user.id,
        pk: isScoredList ? user.id : null,
        userName: isScoredList ? user.targetname : user.username,
        base: user.jidiname,
        gender: user.sex,
        deptName: user.deptname,
        userType: user.usertype,
        score: user.score || '',
        saved: isScoredList
      }))
    },

    focusField(userId) {
      this.currentFocusedUserId = userId
    },

    focusNextField(userId) {
      const focusedIndex = this.showList.findIndex(user => user.id === userId)
      if (focusedIndex !== -1) {
        const nextUser = this.showList[focusedIndex + 1]
        this.currentFocusedUserId = nextUser ? nextUser.id : null
      }
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.van-cell-group {
  &::after {
    border: 1px solid #f2f2f2;
  }
  .van-field__control::placeholder {
    color: @info;
  }
}
</style>
